<template>
    <Select
        v-if="cellEditing || cellEditable"
        v-bind="$attrs"
        v-on="editEvents"
        transfer
        :readonly="!cellEditing || $attrs.readonly"
        :class="prefixCls + '-select'"
        :value="innerValue"
        @input="onSelectChange"
    >
        <Option
            v-for="(item, index) in options"
            :value="item.id"
            :key="item.id"
        >
            {{ item.text }}
        </Option>
    </Select>
    <cell-render
        v-else-if="render"
        :render="render"
        :context="$props"
    ></cell-render>
    <div v-else :class="prefixCls + '-wrap-readonly'" data-cls="cell-content">
        <slot>
            <span>{{ currentText }}</span>
        </slot>
    </div>
</template>
<script>
import mixin from './mixin'
import Input from '../input'
import Select from '../select'
import { Option } from '../select'

export default {
    mixins: [mixin],
    props: {
        optionList: {
            type: [Array, Function],
            default: () => [],
        },
    },
    components: {
        Select,
        Option,
        Input,
    },
    name: 'CellSelect',
    computed: {
        options() {
            var list = this.optionList

            if (typeof list == 'function') {
                list = list(this.getContext())
            }

            return list
        },
        optionsMap() {
            return this.options.reduce((acc, v) => ((acc[v.id] = v), acc), {})
        },
        currentText() {
            var t = ''

            if (this.value) {
                if (this.$attrs.multiple) {
                    t = this.value.split(',').reduce((acc, id) => {
                        var opt = this.optionsMap[id]

                        acc += opt ? opt.text : id
                        acc += ','
                        return acc
                    }, '')

                    if (t.length) {
                        t = t.slice(0, -1)
                    }
                } else {
                    var opt = this.optionsMap[this.value]

                    t = opt ? opt.text : this.value
                }
            }

            return t
        },
        innerValue() {
            return this.$attrs.multiple ? this.value.split(',') : this.value
        },
    },
    methods: {
        onSelectChange(val) {
            if (this.$attrs.multiple) {
                this.onChange(val.join(','))
            } else {
                this.onChange(val)
            }
        },
    },
}
</script>
